export default {
  tabsLabel: {
    id: 'models_comparison_results_tabs_label',
    defaultMessage: 'Comparison sections',
  },
}
